goog.provide('el8.app.shared.network.mappedProfileDetails');

goog.require('el8.appchart.providers.tooltips');
goog.require('el8.appservice.notifier');
goog.require('el8.service.urls');
goog.require('el8.template.app.shared.network.profileDetails');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.consts');
goog.require('el8.util.string');


/**
 *
 */
el8.app.shared.network.mappedProfileDetails = (function() {

    var contactId = null;
    var callbackFn = null;
    var canonicalData = null;
    var fieldsToReset = [];

    var that = new el8.uiwidget.FormDialog({
        title: 'Profile Details',
        contentFn: el8.template.app.shared.network.profileDetails.mappedContent,
        width: 416,
        position: 'center',
        autoHeight: true,
        showXButton: true
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'specialties',
                selector: ':input[name="specialties"]',
                listeditorOpts: function() {
                    var leOpts = el8.appshared.listeditorOpts.medicalSpecialties();
                    return $.extend(leOpts, {
                        list: $('.local-specialties-list', that.getContentElt()),
                        addEntryFn: function() { that.adjustHeight(); },
                        mindreaderOpts: $.extend(leOpts.mindreaderOpts, {
                            selectFn: function(event, item) {
                                form.getListeditor('specialties').addEntry(item);
                            }
                        })
                    });
                },
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'Add a specialty...'
            },
            {
                name: 'address',
                selector: ':input[name="address"]',
                maxLength: 200,
                infoText: 'Street'
            },
            {
                name: 'city',
                selector: ':input[name="city"]',
                maxLength: 50,
                infoText: 'City'
            },
            {
                name: 'state',
                selector: ':input[name="state"]',
                maxLength: 2,
                infoText: 'State'
            },
            {
                name: 'zip',
                selector: ':input[name="zip"]',
                maxLength: 10,
                infoText: 'Zip'
            },
            {
                name: 'phone',
                selector: ':input[name="phone"]',
                maxLength: 20,
                validate: {phone: true}
            },
            {
                name: 'fax',
                selector: ':input[name="fax"]',
                maxLength: 20,
                validate: {phone: true}
            },
            {
                name: 'acceptingNewPatients',
                selector: ':input[name="acceptingNewPatients"]'
            },
            {
                name: 'acceptingInsurance',
                selector: ':input[name="acceptingInsurance"]'
            },
            {
                name: 'insuranceAccepted',
                selector: ':input[name="insuranceAccepted"]',
                height: el8.util.consts.XL_FIELD_HEIGHT,
                maxLength: 200
            },
            {
                name: 'email',
                selector: ':input[name="email"]',
                maxLength: 75
            },
            {
                name: 'directAddress',
                selector: ':input[name="directAddress"]',
                maxLength: 75
            },
            {
                name: 'cellPhone',
                selector: ':input[name="cellPhone"]',
                maxLength: 20,
                validate: {phone: true}
            },
            {
                name: 'backOfficePhone',
                selector: ':input[name="backOfficePhone"]',
                maxLength: 20,
                validate: {phone: true}
            },
            {
                name: 'notes',
                selector: ':input[name="notes"]'
            }
        ],
        validationOpts: el8.util.validate.standardOpts
    });
    form.addSaveButton(saveFn, true);
    form.addDiscardChangesButton(function() { that.hide(); });
    that.setForm(form);


    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        that.getContentElt().on('click', '.show-custom-field',  function() {
            var fieldName = $(this).data('name');
            expandCustomField(fieldName);

        }).on('click', '.replace-with-custom-field',  function() {
            var fieldName = $(this).data('name');
            replaceCanonicalField(fieldName);

        }).on('change', ':input[name="acceptingInsurance"]',  function() {
            if (form.getVal('acceptingInsurance') === '1') {
                form.showField('insuranceAccepted');
            } else {
                form.hideField('insuranceAccepted');
            }

        }).on('click', '.remove-override-trigger',  function() {
            var fieldName = $(this).data('name');
            form.setVal(fieldName, "");
            if (!_.contains(fieldsToReset, fieldName)) {
                fieldsToReset.push(fieldName);
            }
            resetCustomField(fieldName);
        });

        form.hideField('insuranceAccepted');
    };

    var super_show = that.show;
    that.show = function(spec) {
        if (!spec || !spec.contactId) { return; }
        contactId = spec.contactId;
        callbackFn = spec.callbackFn || null;

        if (el8.app.shared.network.unmappedProfileDetails.isOpen()) {
            // only one of these dialogs should be open at a time
            el8.app.shared.network.unmappedProfileDetails.hide();
        }
        super_show.call(that);
        form.getListeditor('specialties').hideLe();
        form.hideField('address');
        form.hideField('phone');
        form.hideField('fax');
        if (el8.data.physicians.getById(contactId).getAccessUserId()) {
            form.disableField('email'); // don't allow changing emails for passport contacts
        }
        createProfileSection();
    };

    var super_hide = that.hide;
    that.hide = function() {
        el8.appchart.providers.tooltips.destroy(that.getContentElt());
        form.enableField('email');
        super_hide.call(that);
        $('.canonical-overview', that.getContentElt()).empty();
        resetCustomFields();
        contactId = null;
        callbackFn = null;
        canonicalData = null;
        fieldsToReset = [];
    };

    /**
     * The profile section is the top of the dialog, which displays details drawn from the canonical
     */
    function createProfileSection() {
        $.el8_ajax({
            url: el8.service.urls.get('connections', [contactId]),
            type: 'GET',
            success: function(data) {
                var connection = el8.data.physicians.create(data.connection);
                canonicalData = data.canonical_info; // required to post specialties properly
                populateProfileData({
                    connection: connection,
                    canonical: data.canonical_info
                });
                bindProfileTriggers();
            }
        });
    }

    function populateProfileData(spec) {
        var $content = that.getContentElt();
        var $overview = $('.canonical-overview', $content);
        var connection = spec.connection;
        var canonical = spec.canonical;
        // Whether this Physician is an actual user account (as opposed to
        // a practice-local contact)
        var connectionIsUser = (connection.getUserId() !== null);
        var connectionIsSelf = (connection.getUserId() === el8Globals.USER_ID);

        var canonicalPhone = canonical.phone;
        var canonicalFax = canonical.fax;
        var canonicalAddress = canonical.address;
        var canonicalInsuranceAccepted = canonical.insurance_accepted || '';

        var canonicalSsClinicName = canonical.ss_clinic_name;

        var soyMap = {
            canonical: el8.util.keysFromUnderscoreToCamel(canonical),
            connectionId: connection.getId(),
            provider: (function() {
                var p = el8.ptdata.ptProviders.getByPhysicianId(connection.getId());
                return p ? p.asSoyMap() : null;
            })()
        };
        $overview.html(
            el8.template.app.shared.network.profileDetails.canonicalOverview(soyMap)
        );
        $('.canonical-specialties-list', $content).html(
            el8.template.app.shared.network.profileDetails.canonicalSpecialties(soyMap)
        );
        $('.canonical-ss-clinic-name', $content).text(canonicalSsClinicName || 'None');
        $('.canonical-address', $content).text(canonicalAddress || 'None');
        $('.canonical-phone', $content).text(canonicalPhone || 'None');
        $('.canonical-fax', $content).text(canonicalFax || 'None');
        $('.canonical-new-pts', $content).html(
            el8.template.app.shared.network.profileDetails.formattedBoolean({ bool: canonical.accepting_new_patients })
        );
        $('.canonical-insurance', $content).html(
            el8.template.app.shared.network.profileDetails.formattedBoolean({ bool: canonical.accepting_insurance })
        );
        if (canonicalInsuranceAccepted && canonical.accepting_insurance) {
            $('.canonical-insurance', $content).append(' (' + canonicalInsuranceAccepted + ')');
        }

        var canonicalSpecialtyIds = _.pluck(canonical.specialties, 'id');
        var localSpecialties = _.reject(connection.getSpecialties(), function(s) {
            return _.contains(canonicalSpecialtyIds, s.id);
        });
        if (localSpecialties.length) {
            form.getListeditor('specialties').addEntries(localSpecialties);
            expandCustomField('specialties');
        }

        if (connection.getFullAddress() && connection.getFullAddress() !== canonicalAddress) {
            form.setVal('address', connection.getAddress());
            form.setVal('city', connection.getCity());
            form.setVal('state', connection.getState());
            form.setVal('zip', connection.getZip());
            expandCustomField('address');
        }
        if (connection.getPhone() && connection.getPhone() !== canonicalPhone) {
            form.setVal('phone', connection.getPhone());
            expandCustomField('phone');
        }
        if (connection.getFax() && connection.getFax() !== canonicalFax) {
            form.setVal('fax', connection.getFax());
            expandCustomField('fax');
        }
        if (connection.getAcceptingNewPatients() !== canonical.accepting_new_patients) {
            form.setVal('acceptingNewPatients', connection.getAcceptingNewPatients());
            replaceCanonicalField('acceptingNewPatients');
        }
        if (connection.getAcceptingInsurance() !== canonical.accepting_insurance ||
                connection.getInsuranceAccepted() !== canonicalInsuranceAccepted) {
            replaceCanonicalField('acceptingInsurance');
            form.setVal('acceptingInsurance', connection.getAcceptingInsurance());
            form.setVal('insuranceAccepted', connection.getInsuranceAccepted());
        }

        form.populate({
            email: connection.getEmail(),
            cellPhone: connection.getCellPhone(),
            backOfficePhone: connection.getBackOfficePhone(),
            directAddress: connection.getDirectAddress(),
            notes: connection.getNotes()
        });

        if (connectionIsUser) {
            // Disable the "preferred address/phone/fax" etc. fields even when
            // editing self, because it's not working right now (when you click
            // save and open your profile again, the changes are gone).
            disableCustomFieldEditing();
            if (!connectionIsSelf) {
                $('.local-only-additional-fields', $content).hide();
            }
        }
        else {
            $('.local-only-additional-fields', $content).show();
        }

        el8.appchart.providers.tooltips.create(that.getContentElt());
        that.adjustPosition();
    }

    function bindProfileTriggers() {
        $('.profile-display-section', that.getContentElt()).on('click', '.connection-write-letter-trigger',  function() {
            var id = $(this).data('id');
            el8.appchart.mgr.thirdpane.setLetterContact(id, 'connection-profile');
            that.hide();

        }).on('click', '.connection-write-referral-trigger',  function() {
            var id = $(this).data('id');
            el8.appchart.mgr.thirdpane.setReferralLetterContact(id, 'connection-profile');
            that.hide();

        });
    }

    // this one shows a custom field, in addition to the value from the canonical
    function expandCustomField(fieldName) {
        $('.show-custom-field[data-name="'+fieldName+'"]', that.getContentElt()).hide();
        if (fieldName === 'specialties') {
            form.getListeditor(fieldName).showLe();
        } else {
            fieldsToReset = fieldsToReset.filter(function (f) { return f !== fieldName; });
            form.showField(fieldName);
        }
        form.focusField(fieldName);
        that.adjustHeight();
    }
    // this one shows just the custom field, hiding the value from the canonical
    function replaceCanonicalField(fieldName) {
        var $target = $('.replace-with-custom-field[data-name="'+fieldName+'"]', that.getContentElt());
        var $section = $target.closest('.el8FieldSection'); // same CSS dependency Form.js has
        $target.hide();
        $('.replace-info', $section).hide();
        $('.custom-field', $section).show();
        that.adjustHeight();
    }
    function resetCustomField(name) {
        $('.show-custom-field[data-name="'+name+'"]', that.getContentElt()).show();
        form.hideField(name);
    }
    function resetCustomFields() {
        var fieldNames = ['address', 'phone', 'fax'];
        fieldNames.forEach(function(name) {
            $('.show-custom-field[data-name="'+name+'"]', that.getContentElt()).show();
            form.hideField(name);
        });
        form.getListeditor('specialties').hideLe();
        $('.show-custom-field[data-name="specialties"]', that.getContentElt()).show();

        $('.replace-info', that.getContentElt()).show();
        $('.replace-with-custom-field', that.getContentElt()).show();
        $('.custom-field', that.getContentElt()).hide();
        // don't call adjustHeight because this usually happens as part of hide() and
        // can be called manually if needed
    }
    function disableCustomFieldEditing() {
        $('.show-custom-field', that.getContentElt()).hide();
        $('.replace-with-custom-field', that.getContentElt()).hide();
        $('.custom-field input', that.getContentElt()).prop('disabled', true);
        $('.custom-field select', that.getContentElt()).prop('disabled', true);
        var fieldNames = ['address', 'city', 'state', 'zip', 'phone', 'fax'];
        fieldNames.forEach(function(name) {
            form.disableField(name);
        });
    }

    function saveFn() {
        if (!contactId) { return; }
        var specialtyIds = _.pluck(form.getListeditor('specialties').getAllEntries(), 'id');
        if (specialtyIds.length && specialtyIds.indexOf(null) !== -1) {
            el8.uiwidget.alert('Please choose specialties from the autocomplete');
            return;
        }

        var postDict = getServerReadyFormMap();

        $.el8_ajax({
            url: el8.service.urls.get('connections', [contactId]),
            type: 'POST',
            data: JSON.stringify(postDict),
            success: function(data) {
                var connection = el8.data.physicians.create(data);
                if (el8.ptdata.ptProviders.getByPhysicianId(contactId)) {
                    // specialty category might have changed -> reload all providers
                    el8.ptdata.ptProviders.load(null, true);
                }
                if (callbackFn) { callbackFn(connection); }
                that.hide();
            }
        });
    }

    // Massage the output of the form so that we can submit it to the server
    function getServerReadyFormMap() {
        var setOverrideField = function(postDict, contactSoyMap, camelKey) {
            var underscoreKey = camelKey.fromCamelToUnderscore();
            if (!postDict[underscoreKey]) {
                if (_.contains(fieldsToReset, underscoreKey)) {
                    postDict[underscoreKey] = canonicalData[underscoreKey];
                } else {
                    postDict[underscoreKey] = contactSoyMap[camelKey];
                }
            }
        };

        var contact = el8.data.physicians.getById(contactId);
        var contactMap = contact.asSoyMap();
        var postDict = form.getMapped(false, true);

        // if the user is changing address, clear suite (since we don't have a field to edit it)
        if (postDict['address']) { postDict['suite'] = ''; }

        // these will be blank in the form if the user wants to keep the existing contact's values
        var overrideFields = ['address', 'city', 'state', 'zip', 'phone', 'fax'];
        overrideFields.forEach(function(fieldName) {
            setOverrideField(postDict, contactMap, fieldName);
        });
        // these are all phone nums - we want to strip non-digit chars
        var phoneFields = ['phone', 'fax', 'cell_phone', 'back_office_phone'];
        phoneFields.forEach(function(fieldName) {
            postDict[fieldName] = el8.util.string.cleanPhoneNum(postDict[fieldName]);
        });

        // submit just the specialty_ids (not the whole object pulled out of the LE)
        var specialtyIds = _.map(
            form.getListeditor('specialties').getAllEntries(),
            function(entry) { return parseInt(entry.id, 10); }
        ); // 'id' from the LE is usually a String
        var canonicalSpecialtyIds = _.pluck(canonicalData.specialties, 'id');
        var specialtyIds = _.difference(specialtyIds, canonicalSpecialtyIds); // ignore any locals already on the canonical
        postDict['specialty_ids'] = canonicalSpecialtyIds.concat(specialtyIds); // canonicals first, then locals
        delete postDict['specialties'];

        // convert acceptingInsurance / Patient ints to bools
        (['accepting_insurance', 'accepting_new_patients']).forEach(function(fieldName) {
            if (postDict[fieldName] === '1') {
                postDict[fieldName] = true;
            } else if (postDict[fieldName] === '0') {
                postDict[fieldName] = false;
            } else {
                postDict[fieldName] = null;
            }
        });
        if (!postDict['accepting_insurance']) {
            postDict['insurance_accepted'] = null; // clear the insurance textfield if insurance isn't accepted
        }

        return postDict;
    }

    return that;

})();
